import i18n from '@/configs/i18n'
import vi from './vi.json'
import en from './en.json'
import viErrors from './axios-error.vi.json'
import enErrors from './axios-error.en.json'

i18n.addResourceBundle('vi', 'purchasing-payments', vi)
i18n.addResourceBundle('en', 'purchasing-payments', en)
i18n.addResourceBundle('vi', 'axios-error', viErrors, true, false)
i18n.addResourceBundle('en', 'axios-error', enErrors, true, false)
